/**
 * MUI-тема интерфейса кладовщика (светлая, по токенам админки).
 * Переопределения здесь закрывают базовые компоненты, чтобы на экранах
 * не приходилось раскрашивать каждый элемент через sx.
 */
import { createTheme } from "@mui/material";
import { ds, fontFamily, TAP } from "./tokens";

export const keeperMuiTheme = createTheme({
  palette: {
    mode: "light",
    primary: { main: ds.primary, dark: ds.primaryHover, light: ds.primarySoft },
    success: { main: ds.success },
    warning: { main: ds.warning },
    error: { main: ds.danger },
    info: { main: ds.info },
    background: { default: ds.bg, paper: ds.surface },
    text: { primary: ds.text, secondary: ds.text2, disabled: ds.text3 },
    divider: ds.border,
  },
  shape: { borderRadius: ds.radius },
  typography: {
    fontFamily,
    button: { textTransform: "none", fontWeight: 600 },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: ds.bg,
          color: ds.text,
          WebkitFontSmoothing: "antialiased",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: ds.surface,
          borderRadius: ds.radius,
          "& fieldset": { borderColor: ds.border2 },
          "&:hover fieldset": { borderColor: "#9fb8de" },
          "&.Mui-focused": { boxShadow: ds.focusRing },
          "&.Mui-focused fieldset": { borderColor: ds.primary, borderWidth: "1px" },
        },
        input: {
          color: ds.text,
          "&::placeholder": { color: ds.text3, opacity: 1 },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: ds.radius, minHeight: TAP, paddingInline: 20 },
        contained: { boxShadow: ds.shadowXs, "&:hover": { boxShadow: ds.shadowMd } },
        outlined: {
          borderColor: ds.border2,
          color: ds.text,
          backgroundColor: ds.surface,
          "&:hover": { borderColor: ds.primary, backgroundColor: ds.primarySoft },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: { color: ds.text2, borderRadius: ds.radius },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { borderRadius: 999, fontWeight: 700 },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        switchBase: {
          "&.Mui-checked": { color: ds.surface },
          "&.Mui-checked + .MuiSwitch-track": { backgroundColor: ds.primary, opacity: 1 },
        },
        track: { backgroundColor: ds.border2, opacity: 1 },
        thumb: { boxShadow: ds.shadowXs },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: { backgroundColor: ds.surface3, borderRadius: 999 },
        bar: { borderRadius: 999 },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: ds.radiusLg,
          border: `1px solid ${ds.border}`,
          boxShadow: ds.shadowLg,
          backgroundColor: ds.surface,
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: { color: ds.text, fontWeight: 700 },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: ds.text,
          borderRadius: ds.radiusSm,
          fontSize: "0.72rem",
        },
      },
    },
  },
});

export default keeperMuiTheme;
